import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UsersService } from 'src/app/data/services/users.service';
import { RoleService } from '../auth/services/role.service';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

export const homeResolver: ResolveFn<string> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<string> => {
  const userService = inject(UsersService);
  const roleService = inject(RoleService);

  return userService.user$.pipe(
    filter(user => user !== null),
    take(1),
    map(user => {
      if (!user) return '/login';
      return roleService.getHomeRouteForGroup(user.group);
    })
  );
};